import React, { useState, type HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface Tab {
  label: string;
  subLabel?: string;
  content: React.ReactNode;
}

interface IBaseTabs {
  tabs: Tab[];
  onTabClick?: (key: number) => void;
  tabContainerStyle?: string;
  tabBarContainerStyle?: string;
  activeTextColor?: string;
  activeBgColor?: string;
}

type TBaseModalProps = IBaseTabs & HTMLAttributes<HTMLDivElement>;

const BaseTabs: React.FC<TBaseModalProps> = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const {
    tabs,
    onTabClick,
    className,
    tabContainerStyle,
    tabBarContainerStyle,
    activeBgColor = "bg-selectedDark",
    activeTextColor = "text-white",
    ...otherProps
  } = props;

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    if (onTabClick) {
      onTabClick(index);
    }
  };

  return (
    <div>
      {/* tabs */}
      <div
        className={twMerge(
          "tabs bg-mainDark rounded-full px-2 py-[0.375rem] flex justify-evenly",
          className
        )}
        {...otherProps}
      >
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={twMerge(
              `tab tab-bordered flex flex-col w-fit min-w-20 text-xs rounded-full opacity-80 font-semibold ${activeTab === index ? `tab-active ${activeTextColor} ${activeBgColor} opacity-100` : "text-white"}`,
              tabBarContainerStyle
            )}
            onClick={() => handleTabClick(index)}
          >
            <div> {`${t(tab.label)}`}</div>
            {tab.subLabel && <div className="text-xs">{tab.subLabel}</div>}
          </div>
        ))}
      </div>

      {/* tab content */}
      <div className={twMerge("my-6", tabContainerStyle)}>
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

export default BaseTabs;
